export default "__VITE_ASSET__fyG3bw0Z__"